import React from 'react';
import PropTypes from 'prop-types';
import RadioButton from './RadioButton';
import css from './MultipleChoiceField.scss'
import Icon from 'SF/MaterialIcon';

const YesNoField = (props) => {

  const options = [
    {
      display: "Yes",
      value: true
    },
    {
      display: "No",
      value: false
    }
  ];

  const changeHandler = (index) => {
    props.setValue(options[index].value)
  }

  const isRadioButtonSelected = (value) => {
    if (props.value === null) return false;
    return (props.value === value)
  }

  const { isReadOnly, hasError, questionNumber, questionText } = props
  return (
    <>
      <div className={css['multiple-choice-wrapper']} role="radiogroup" aria-label={questionText}>
        {options.map((option, index) =>
          <RadioButton
            key={index}
            value={option.value}
            label={option.display}
            checked={isRadioButtonSelected(option.value)}
            onChange={() => changeHandler(index)}
            disabled={isReadOnly}
            name={`yesNo_${questionNumber}`}
          />
        )}
      </div>
      {hasError && !isReadOnly && (
        <div className={css['input-error-message-block']} role="alert">
          <Icon icon="error" /><p>Invalid option selected</p>
        </div>
      )}
    </>
  )
}

YesNoField.propTypes = {
  value: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  hasError: PropTypes.bool,
  setValue: PropTypes.func
}
export default YesNoField;
